import { Box, Container, Paper } from "@mui/material";
import React from "react";
import variables from "../../../assets/styles/variables.module.scss";
import PlaygroundHandler from "./Playground";
import { PlayGroundSize } from "../../../Constant/Setting";

const Playground = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Container maxWidth={PlayGroundSize} sx={{height: "100%"}}>
        <PlaygroundHandler />
      </Container>
    </Box>
  );
};

export default Playground;
